import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { styled } from '@mui/material/styles';
// @mui
import {  
          Container, 
          Button, 
          Box,
          IconButton,
          InputLabel,
          MenuItem,
          Select,
          FormControl,
          Stack,
          Autocomplete,
          TextField,
          Typography

} from '@mui/material';

import Iconify from '../components/iconify';
import KanbanBoard from '../kanban/KanbanBoard';
// import Header from '../layouts/dashboard/header2'
import Nav from '../layouts/dashboard/nav2'
import PopoverFiltro from './PopoverFiltro';

// api
import { validateUser, getFluxogramas } from './api'
import config from '../config.json';
import { cores } from '../styles/styleUtils';




const StyledAppBar = styled(Stack)(() => ({
  height: 64,
  direction: 'row',
  alignItems: 'center',
  backgroundColor: cores.chumbo,
  paddingLeft: 16,
  paddingRight: 16,
  gap: 20,
  marginBottom: 10,

}));


// ----------------------------------------------------------------------

export default function Kanban() {
  const [fluxogramas, setFluxogramas] = useState([])
  useEffect(() => { fetchFluxos() }, []);
  
  const fetchFluxos = () => {
    getFluxogramas()
      .then((dados) => {
        setFluxogramas(dados);
      })
      .catch((error) => {
        // Trate erros aqui
        window.alert("Erro ao consultar banco de dados")
        console.error('Erro ao buscar dados da API:', error);
      });
  }

  // Outras funcoes e declaracoes
  // ---------------------
  const [open, setOpen] = useState(false);
  const onOpenNav = () => setOpen(true);
  const [fluxogramaSelecionado, setFluxogramaSelecionado] = useState('');
  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser()
  },[])
  const validateuser = async () => {
    const teste = await validateUser();
    if(!teste.ok){
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {}
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente')
      return
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario
  }
  // -------------
  // Filtro ----
  const dataAtual = new Date();
  const primeiroDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
  const ultimoDiaDoMes = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);
  const emptyFiltro = {
    usuario: JSON.parse(localStorage.getItem('userData')),
    datainicial: primeiroDiaDoMes, 
    datafinal: ultimoDiaDoMes,
  }
  const [filtro, setFiltro] = useState({...emptyFiltro});
  const [openFiltro, setOpenFiltro] = useState(null)

  const onCloseFiltro = () => {
    setOpenFiltro(null)
  }

  const limparFiltro = () => {
    setFiltro({...emptyFiltro})
    setFluxogramaSelecionado('')
    setOpenFiltro(null)
  }
  
  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover)
    setFluxogramaSelecionado(filtroPopover.fluxo)
  }

  const handleChange = (event) => {
    setFiltro({...filtro, fluxo: event.target.value})
    setFluxogramaSelecionado(event.target.value);
  };

  const renderContent = (
    <StyledAppBar direction={'row'} alignItems="center">
      <IconButton
          onClick={onOpenNav}
          sx={{
            color: 'text.primary',
            backgroundColor: 'white'
          }}
        >
        <Iconify icon="eva:menu-2-fill" />
      </IconButton>
      {/*
      <FormControl sx={{ minWidth: 220}} size="small">
        <InputLabel id="fluxograma">Fluxograma</InputLabel>
        <Select
          labelId="fluxograma"
          id="fluxogramaselect"
          value={fluxogramaSelecionado}
          label="Fluxograma"
          onChange={handleChange}
          sx={{backgroundColor: 'white'}}
        >
          {fluxogramas.map((fluxo) => {
            return <MenuItem key={fluxo.id} value={fluxo}>{fluxo.nome}</MenuItem>
          })}
        </Select>
      </FormControl>
      */}
      <Stack direction={'row'} alignItems="center" spacing={1.5}>
        <Typography variant="body2" sx={{ color: cores.branco, whiteSpace: 'nowrap' }}>
          Selecione o Fluxo
        </Typography>
        <Autocomplete
          disablePortal
          id="fluxograma"
          value={filtro.fluxo || null}
          onChange={(event, newValue) => {
            setFiltro({...filtro, fluxo: newValue})
          }}
          options={fluxogramas || []}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => `${option.nome}`}
          renderInput={(params) => <TextField {...params} sx={{backgroundColor: cores.branco}}/>}
          sx={{minWidth: 220}} size="small"
        />
      </Stack>
      <Button size={'small'} onClick={(e) => setOpenFiltro(e.currentTarget)} variant="contained" startIcon={<Iconify icon="eva:search-fill" />}  sx={{ml: 'auto', height: 40, minWidth: 100, backgroundColor: cores.laranja,  '&:hover': {backgroundColor: cores.laranjaEscuro}}}>
        Filtros
      </Button>
    </StyledAppBar>
    
  );
  // ----------------------

  return (
    <>
      <Helmet>
        <title> Kanban </title>
      </Helmet>

        {renderContent}

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />
      <Container maxWidth="xl">
        {
          filtro.fluxo ? 
            <KanbanBoard filtro={filtro} fluxo={filtro.fluxo} etapas={filtro.fluxo.etapas}/> 
            : null
        }        
      </Container>
      {
        openFiltro ? 
          <PopoverFiltro filtro={filtro} open={openFiltro} onClose={onCloseFiltro} onLimpar={limparFiltro} onConfirm={onConfirmFiltro}/> 
        : null
      }
    </>
  );
}